import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useLazyTokensChatIssueRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { selectCurrentMembership } from 'src/features/auth/selectors';

import { setChatError, setSendbirdAccessToken } from './chat.slice';
import { useIsChatEnabled } from './useIsChatEnabled';

export function useResolveChatTokenIfEnabled() {
  const dispatch = useAppDispatch();
  const currentMembership = useAppSelector(selectCurrentMembership);
  const [getChatToken] = useLazyTokensChatIssueRetrieveQuery();
  const sendBirdAccessToken = useAppSelector(
    (state) => state.chat.sendbirdAccessToken
  );
  const membershipTokenMap = useAppSelector(
    (state) => state.chat.membershipTokenMap
  );
  const isChatEnabled = useIsChatEnabled();

  useEffect(() => {
    if (
      isChatEnabled &&
      typeof currentMembership?.id === 'string' &&
      !!currentMembership.id &&
      !sendBirdAccessToken
    ) {
      dispatch(setChatError(false));
      getChatToken({}).then(({ data, error }) => {
        if (error) {
          dispatch(setChatError(true));
        } else if (
          data &&
          // Extra check of currentMembership.id is string for ts
          typeof currentMembership.id === 'string' &&
          !!currentMembership.id
        ) {
          dispatch(
            setSendbirdAccessToken({
              membershipId: currentMembership.id,
              sendbirdAccessToken: data.token,
            })
          );
        }
      });
    }
  }, [
    dispatch,
    getChatToken,
    isChatEnabled,
    currentMembership?.id,
    sendBirdAccessToken,
    membershipTokenMap,
  ]);

  return sendBirdAccessToken;
} 